import { useEffect, useState, useRef, createContext, Fragment } from "react";
import { setCanonical } from "../components/misc/Util";
import Background from "../components/misc/Background";
import Filter from "../components/summoner/Filter";
import LivePanel from "../components/summoner/LivePanel";
import Loading from "../components/misc/Loading";
import Match from "../components/match/Match";
import MatchTiny from "../components/match/MatchTiny";
import MatchLoad from "../components/match/MatchLoad";
import Players from "../components/summoner/Players";
import RecentStats from "../components/summoner/RecentStats";
import Summary from "../components/summoner/Summary";
import Header from "../components/summoner/Header";
import TabButtons from "../components/summoner/TabButtons";
import useFetch from "../components/hooks/useFetch";
import useWidth from "../components/hooks/useWidth";
import Wrapper from "../components/misc/Wrapper";
import { useParams } from "react-router-dom";
import styles from "./Summoner.module.css";

export const SumContext = createContext(null);

const Summoner = () => {
  const width = useWidth();
  const initalCount = 20;
  const [scroller, setScroller] = useState({ height: 0, show: initalCount });
  const ref = useRef(null);
  const { summoner } = useParams();
  const [riotName, riotTag] = summoner.split("-");

  const summonerName =
    riotName.toLowerCase().replace(/\s/g, "") + "-" + riotTag;
  const [delay, setDelay] = useState({});
  const key = summonerName;
  const API = `https://p1.xdx.gg`;
  const URL = `${API}/rid/1/${summonerName}`;
  const cDelay = delay[key] ? delay[key] : 0;
  const sum = useFetch(URL, key, cDelay)[key];
  const statsURL =
    sum && sum.puuid ? `${API}/statssingle/1/${sum.puuid}/` : false;
  const stats = useFetch(statsURL, key)[key];
  const [matchData, setMatchData] = useState({});
  const [sumData, setSumData] = useState({});
  const [cidFilter, setCidFilter] = useState(false);
  const [qFilter, setQFilter] = useState(false);
  const filterChamp = (e) => {
    const cid = parseInt(e.target.parentElement.getAttribute("data-id"));
    if (cid === cidFilter) setCidFilter(false);
    else setCidFilter(cid);
    setScroller({ height: 0, show: initalCount });
  };
  const filterQueue = (e) => {
    const q = parseInt(e.target.getAttribute("data-id"));
    if (q === qFilter) setQFilter(false);
    else setQFilter(q);
    setScroller({ height: 0, show: initalCount });
  };
  const clearFilter = () => {
    setCidFilter(false);
    setQFilter(false);
    setScroller({ height: 0, show: initalCount });
  };

  useEffect(() => {
    setSumData({});
    setMatchData({});
    setScroller({ height: 0, show: initalCount });
  }, [summonerName]);

  useEffect(() => {
    const scroll = () => {
      if (!ref.current) return;
      const rect = ref.current.getBoundingClientRect();
      if (rect.height === 0 || window.pageYOffset < 1) return;
      const baseY = rect.top + rect.height - window.innerHeight;
      if (rect.height > scroller.height && baseY < 300) {
        setScroller({
          height: rect.height + 1,
          show: scroller.show < 100 ? scroller.show + 10 : 100,
        });
        window.removeEventListener("scroll", scroll);
      }
    };
    window.addEventListener("scroll", scroll, false);
    return () => window.removeEventListener("scroll", scroll);
  }, [scroller]);

  useEffect(() => {
    if (sum && sum.name) {
      let recent = localStorage.getItem("recent")
        ? JSON.parse(localStorage.getItem("recent"))
        : [];
      recent = recent.filter((r) => (r === sum.name ? false : true));
      if (recent.length > 9) recent.shift();
      recent.push(sum.name);
      localStorage.setItem("recent", JSON.stringify(recent));
    }
  }, [sum]);

  useEffect(() => {
    if (!sum && scroller.show !== initalCount)
      setScroller({ height: 0, show: initalCount });
  }, [sum, scroller]);

  useEffect(() => {
    if (sum && !delay[key]) {
      const request = Math.round(
        Date.now() / 1000 -
          Math.min(sum["request-ranks"], sum["request-matches"])
      );
      const modified = Math.round(
        Date.now() / 1000 -
          Math.min(sum["modified-ranks"], sum["modified-matches"])
      );
      if (request < 15 && modified > 60) setDelay({ [key]: 3000 });
    }
  }, [sum, key, delay]);

  let mids =
    sum && sum.matches
      ? sum.matches.map((mid) =>
          typeof sumData[mid[0]] !== "undefined"
            ? [
                mid[0],
                sumData[mid[0]].cid,
                sumData[mid[0]].queue,
                sumData[mid[0]].timestamp,
              ]
            : mid
        )
      : [];

  let fMids = mids.filter((mid) =>
    (cidFilter && cidFilter !== mid[1]) || (qFilter && qFilter !== mid[2])
      ? false
      : true
  );

  let again = true;
  while (again) {
    again = false;
    for (let i = 0; i < fMids.length - 1; i++) {
      if (
        typeof fMids[i][3] !== "undefined" &&
        typeof fMids[i + 1][3] !== "undefined" &&
        fMids[i][3] < fMids[i + 1][3]
      ) {
        const t = fMids[i];
        fMids[i] = fMids[i + 1];
        fMids[i + 1] = t;
        again = true;
      }
    }
  }

  let lastChamp = false;
  fMids.forEach((mid) => {
    if (!lastChamp && typeof mid[1] !== "undefined") lastChamp = mid[1];
  });

  fMids = fMids.slice(0, scroller.show);

  if (sum && !sum.puuid)
    return (
      <Background cid={0}>
        <Wrapper>
          <div class={styles.notfound}>
            <center>
              <h1>Summoner Not Found</h1>
              <h2>The new format is summoner#tag</h2>
              <h2>Please double check and try again.</h2>
            </center>
          </div>
        </Wrapper>
      </Background>
    );

  if (sum && sum.name) {
    document.title = document.getElementsByTagName("meta")[1].content =
      "LoL " + sum.name + " " + sum.region.toUpperCase() + " XDX Profile";
    setCanonical("https://xdx.gg/" + sum.region + "/" + summonerName);
  }
  return (
    <Background cid={lastChamp}>
      <Wrapper>
        <Header sum={sum} width={width} />
        {sum && sum.matches && (
          <TabButtons tab={0} region={sum.region} summonerName={summonerName} />
        )}
        <div className={styles["main_" + width]}>
          <div ref={ref} className={styles.content}>
            {(!sum || !sum.matches) && <Loading />}
            {sum && sum.matches && (
              <div>
                <Filter
                  mids={mids}
                  cid={cidFilter}
                  queue={qFilter}
                  filterChamp={filterChamp}
                  filterQueue={filterQueue}
                  clearFilter={clearFilter}
                />
                <Summary mids={fMids} summary={sumData} width={width} />
                <SumContext.Provider
                  value={{ sumData, setSumData, matchData, setMatchData }}
                >
                  {width === "tiny" &&
                    fMids.map((match) => (
                      <Fragment key={match[0]}>
                        {matchData[match[0]] && (
                          <MatchTiny
                            data={matchData[match[0]]}
                            region={sum.region}
                            mid={match[0]}
                            puuid={sum["puuid"]}
                            width={width}
                          />
                        )}
                        {!matchData[match[0]] && (
                          <MatchLoad
                            region={sum.region}
                            mid={match[0]}
                            puuid={sum["puuid"]}
                            width={width}
                          />
                        )}
                      </Fragment>
                    ))}
                  {width !== "tiny" &&
                    fMids.map((match) => (
                      <Fragment key={match[0]}>
                        {matchData[match[0]] && (
                          <Match
                            data={matchData[match[0]]}
                            region={sum.region}
                            mid={match[0]}
                            puuid={sum["puuid"]}
                            width={width}
                          />
                        )}
                        {!matchData[match[0]] && (
                          <MatchLoad
                            region={sum.region}
                            mid={match[0]}
                            puuid={sum["puuid"]}
                            width={width}
                          />
                        )}
                      </Fragment>
                    ))}
                </SumContext.Provider>
                {/* { show < maxMatches && <div className={styles.more} onClick={loadMore}>LOAD MORE</div> } */}
              </div>
            )}
          </div>
          {sum && sum.matches && (width === "xlarge" || width === "large") && (
            <div className={styles.sidebar}>
              <LivePanel region={sum.region} pid={sum["puuid"]} />
              <RecentStats stats={stats} />
              <Players
                type="teamMates"
                region={sum.region}
                puuid={sum["puuid"]}
                mids={fMids}
                summary={sumData}
              />
              <Players
                type="enemies"
                region={sum.region}
                puuid={sum["puuid"]}
                mids={fMids}
                summary={sumData}
              />
            </div>
          )}
        </div>
      </Wrapper>
    </Background>
  );
};

export default Summoner;
